<template>
    <div class="upload-bottom" :class="sb?'sb':''">
        <!-- <a href="./excel/a.docx" download="">111111111</a> -->
        <Form ref="form" :model="form2" :label-width="160">
            <AgentCollapse title="上传附件" tips="支持扩展名为.png,.jpg,.jpeg,.xls,.xlsx,.pdf,.tif,.tiff,.dox,.docx的文件"
                type="plan" red>
                <div slot="content">
                    <template v-if="taskName.indexOf('上传投保单') != -1">
                        <Row v-for="(item, index) in form2.list1" :key="index">
                            <Col span="24">
                            <Form-item label="上传投保单" :prop="'list1.' + index + '.fileName'"
                                :rules="{required: true,  message: '上传投保单', trigger: 'change'}">
                                <Input v-model="item.fileName" clearable readonly placeholder="请上传"
                                    style="width:277px"></Input>
                                <UploadFile @on-success="val=>{uploaded(val, index, 'list1',item)}" type="select"
                                    :accept="['image','word','pdf','excel']">
                                    <Button type="info">上传</Button>
                                </UploadFile>
                                <Button type="info"
                                    @click="downloadd('/broker/export/exportApplication',{applicationId:form.insuranceApplicationId,productCode:form.productCode})">下载打印投保单</Button>
                                <!-- <Button type="info" @click="downloadd(1)">下载打印投保单</Button> -->
                                <Button @click=" delListO(index)" type="error" v-if="index!=0">删除</Button>
                            </Form-item>
                            </Col>
                        </Row>
                        <Row v-for="(item, index) in form2.list7" :key="item.fileType">
                            <Col span="24">
                            <Form-item label="凭证" :prop="'list7.' + index + '.fileName'">
                                <Input v-model="item.fileName" clearable readonly placeholder="请上传"
                                    style="width:277px"></Input>
                                <UploadFile @on-success="val=>{uploaded(val, index, 'list7',item)}" type="select"
                                    :accept="['image','word','pdf','excel']">
                                    <Button type="info">上传</Button>
                                </UploadFile>
                            </Form-item>
                            </Col>
                        </Row>
                    </template>
                    <template v-if="taskName.indexOf('上传批改单') != -1">
                        <Row v-for="(item, index) in form2.list5" :key="'ENDORSE'+index">
                            <Col span="24">
                            <Form-item label="上传批改单" :prop="'list5.' + index + '.fileName'"
                                :rules="{required: true,  message: '上传批单', trigger: 'change'}">
                                <Input v-model="item.fileName" clearable readonly placeholder="请上传"
                                    style="width:277px"></Input>
                                <UploadFile @on-success="val=>{uploaded(val, index, 'list5',item)}" type="select"
                                    :accept="['image','word','pdf','excel']">
                                    <Button type="info">上传</Button>
                                </UploadFile>
                                <!-- <Button type="info"
                                    @click="exportToExcel('/pdf/printEndorse',{applicationId:form.insuranceApplicationId,productCode:form.productCode})">下载打印批单1</Button> -->
                                <Button type="info" @click="downloadds(2)">下载打印批单</Button>
                                <Button @click=" delListF(index)" type="error" v-if="index!=0">删除</Button>
                            </Form-item>
                            </Col>
                        </Row>
                        <Row v-for="(item, index) in form2.list8" :key="item.fileType">
                            <Col span="24">
                            <Form-item label="凭证" :prop="'list8.' + index + '.fileName'">
                                <Input v-model="item.fileName" clearable readonly placeholder="请上传"
                                    style="width:277px"></Input>
                                <UploadFile @on-success="val=>{uploaded(val, index, 'list8',item)}" type="select"
                                    :accept="['image','word','pdf','excel']">
                                    <Button type="info">上传</Button>
                                </UploadFile>
                            </Form-item>
                            </Col>
                        </Row>
                    </template>
                    <template>
                        <Row>
                            <Col span="24">
                            <Button type="primary" @click="addListO">{{taskName.indexOf('上传投保单') != -1?'添加投保单':'添加批改单'}}
                            </Button>
                            <Button type="primary" @click="valid(1)">提交</Button>
                            </Col>
                        </Row>
                    </template>

                </div>
            </AgentCollapse>
        </Form>
    </div>
</template>

<script>
    import AgentCollapse from '@/components/agent/AgentCollapse'
    import UploadFile from '@/components/common/UploadFileImg'
    export default {
        components: { AgentCollapse, UploadFile },
        props: {
            form: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            taskName: {
                type: String,
                default: ''
            }
        },
        data () {
            return {
                form2: {
                    list0: [{ fileType: 'APPLICATION' }], //投保确认书
                    list1: [{ fileType: 'APPLICATION' }], //投保单
                    list2: [{ fileType: 'STATEMENTS' }], //结算单/内结单
                    list3: [{ fileType: 'POLICY' }], //保单
                    list4: [{ fileType: 'INVOICE' }],//发票
                    list5: [{ fileType: 'ENDORSE' }],//批改单
                    list6: [{ fileType: 'ENDORSE_POLICY' }],//批改保单
                    list7: [{ fileType: 'RECEIPT_VOUCHER' }], //凭证
                    list8: [{ fileType: 'RECEIPT_VOUCHER' }], //凭证
                },
                index: 0,
                sb: false
            }
        },
        created () {
            var that = this
            window.onscroll = function () {
                //变量scrollTop是滚动条滚动时，距离顶部的距离
                var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                //变量windowHeight是可视区的高度
                var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
                //变量scrollHeight是滚动条的总高度
                var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
                //滚动条到底部的条件
                // console.log(scrollTop+windowHeight+428,scrollHeight)
                if (scrollTop + windowHeight + 228 >= scrollHeight) {
                    //写后台加载数据的函数
                    that.sb = true
                    // console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight);
                } else {
                    that.sb = false
                }
            }
        },
        methods: {
            /*上传成功回调*/
            uploaded (file, index, list, item) {
                let obj = {
                    fileUrl: file.url,
                    fileName: file.name,
                    fileType: item.fileType
                }
                if (item.fileNo) obj.fileNo = item.fileNo
                this.$set(this.form2[list], index, obj)
            },
            exportToExcel (url, params = {}) {
                this.$axios.post('/broker/export/exportApplication.json', {
                    bizId: 'JIANGONG_EMPLOYER_LIABILITY',
                    productCode: this.form.productCode,
                    applicationId: this.form.insuranceApplicationId
                }).then(res => {
                    if (res) {
                        this.getBlob(res).then((blob) => {
                            this.saveAs(blob, '投保单')
                        })
                    }
                })
                // const rootUrl = '/pc'
                // url = location.origin + rootUrl + url + '?';
                // for (var i in params) {
                //     url += i + '=' + (params[i] || '') + '&'
                // }
                // url = url.substring(0, url.length - 1);
                // // return;
                // // console.log(url)
                // window.open(url)
            },
            getBlob (url) {
                return new Promise((resolve) => {
                    const xhr = new XMLHttpRequest()
                    xhr.open('GET', url, true)
                    xhr.responseType = 'blob'
                    xhr.onload = () => {
                        if (xhr.status === 200) {
                            resolve(xhr.response)
                        }
                    }
                    xhr.send()
                })
            },
            // 封装一个download方法
            downloadA(url,name){
                const x = new window.XMLHttpRequest();
                x.open('GET', url, true);
                x.responseType = 'blob';
                x.onload = () => {
                const url = window.URL.createObjectURL(x.response);
                const a = document.createElement('a');
                a.href = url;
                a.download = name;
                a.click();
                };
                x.send();
            },
            //点击下载
            downloadd (url,params={}) {
                this.$axios.post('/broker/export/exportApplication.json',
                {applicationId:this.form.insuranceApplicationId,productCode:this.form.productCode,bizId:'JIANGONG_EMPLOYER_LIABILITY'} ).then(res=>{
                    if (res) {
                        this.downloadA(res,'投保单-雇主.xlsx' ) 
                    }
                })

            },
            downloadds(num){
                var a = document.createElement('a') // 创建一个<a></a>标签
                if (num == 1) {
                    a.href = '/static/excel/投保单-雇主.docx'         //重点（如测试发现下载文件不存在/找不到，检查路径）
                    a.download = '投保单-雇主.docx'         // 设置下载文件文件名
                } else {
                    a.href = '/static/excel/阳光-批改申请单-延期.doc'         //重点（如测试发现下载文件不存在/找不到，检查路径）
                    a.download = '阳光-批改申请单-延期.doc'
                }
                a.style.display = 'none'
                document.body.appendChild(a)
                a.click()
                a.remove()
            },
            // 提交
            async valid (a) {
                let valid = await this.$refs.form.validate()
                if (valid) {
                    let obj = {}
                    obj.bizId = this.form.bizId
                    obj.productCode = this.form.productCode
                    obj.taskId = this.$route.query.taskId
                    obj.isApplication = true
                    if (this.taskName == '上传批改单') {
                        obj.isApplication = false
                        obj.endorseId = this.form.endorseId
                        obj.applicationId = this.form.insuranceApplicationId
                        obj.fileList = []
                        this.form2.list5.forEach(element => {
                            obj.fileList.push(element)
                        });
                        if(this.form2.list8[0].fileUrl){
                            obj.fileList.push(this.form2.list8[0])
                        }
                        await this.$axios.post('/broker/attachment/uploadAttachmentFile.json', obj)
                        this.toast('提交成功')
                        window.open('/haierProduct.html#/my/customized/correction', '_self')
                    } else {
                        obj.applicationId = this.form.insuranceApplicationId
                        obj.fileList = []
                        this.form2.list1.forEach(element => {
                            obj.fileList.push(element)
                        });
                        if(this.form2.list7[0].fileUrl){
                            obj.fileList.push(this.form2.list7[0])
                        }
                        await this.$axios.post('/broker/attachment/uploadAttachmentFile.json', obj)
                        this.toast('提交成功')
                        this.$router.replace('/my/customized/task')
                    }
                }
            },
            addListO () {
                console.log(11)
                if (this.taskName.indexOf('上传投保单') != -1) {
                    this.form2.list1.push({ fileType: 'APPLICATION' })
                } else {
                    this.form2.list5.push({ fileType: 'APPLICATION' })

                }
            },
            delListO (val) {
                this.form2.list1.splice(val, 1)
            },
            delListF (val) {
                this.form2.list5.splice(val, 1)
            },
        }
    }
</script>
<style scoped>
    .iclose {
        font-size: 30px;
        cursor: pointer;
    }

    .agent-form-detail {
        word-break: break-all;
        line-height: 34px;
    }

    .upload-bottom {
        position: fixed;
        z-index: 10;
        bottom: 0px;
        width: 1200px;

    }

    .upload-bottom.sb {
        bottom: 422px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/common/customized/UploadInsurance.vue